import React from 'react'
import {Navbar} from 'react-bootstrap'
import './style.css'

export default function nav_judul() {
    return (
        <Navbar.Brand href="/">Mal<span>mora.</span></Navbar.Brand>
    )
}
